export default __webpack_public_path__ + "static/media/ic_adviser.9967e58a.svg";